import React, { FC } from 'react'
import styled from 'styled-components'

import { RewardsQuery } from '../../../../../../graphql/search'
import useSiteMetadata from '../../../../../../hooks/useSiteMetadata'
import { usePractitionerSettings } from '../../../../../../lib/practitioner-settings/hooks/usePractitionerSettings'
import { commissionsCashBack } from '../../../../../../lib/rewards/commissions'
import { dropZeroCents, formatAsCurrencyWithCommasOrZero } from '../../../../../../utils/priceTools'
import { InformationIcon, NoticeCard, NoticeLink, NoticeText } from '../../RewardsNotice'
import * as Styled from './styled'

export interface YourRewardsCardProps {
  className?: string
  availableBalance: NonNullable<NonNullable<RewardsQuery['customer']>['availableBalance']>
}

const StyledCardInnerContainer = styled.div`
  max-width: 452px;
  width: inherit;
`

export const YourRewardsCard: FC<YourRewardsCardProps> = ({ className, availableBalance }) => {
  const { featureFlags } = useSiteMetadata() ?? {}
  const { commissionsBalance, totalBalance } = availableBalance

  const [settings] = usePractitionerSettings()
  const optedOutOfCommissions = settings?.practitioner?.commissionsOptOutFormReceived ?? false
  const optedOutOfRebates = !settings?.practitioner?.enrolledInRebate

  return (
    <Styled.Card className={className}>
      <StyledCardInnerContainer>
        <Styled.Heading4>Your Rewards</Styled.Heading4>
        {optedOutOfCommissions && optedOutOfRebates ? (
          <Styled.NoticeCardContainer>
            <NoticeCard>
              <InformationIcon />
              <NoticeText>
                {`You're missing out on commissions and rebates! `}
                <NoticeLink to="/account/settings/rewards-program">
                  Sign up now to start gaining these benefits.
                </NoticeLink>
              </NoticeText>
            </NoticeCard>
          </Styled.NoticeCardContainer>
        ) : (
          <>
            <Styled.AvailableContainer>
              <Styled.AvailableRewards>
                {dropZeroCents(
                  formatAsCurrencyWithCommasOrZero({ amount: parseFloat(totalBalance.amount) }),
                )}
              </Styled.AvailableRewards>
              available
            </Styled.AvailableContainer>
            {featureFlags?.commissionsCashBack && (
              <Styled.CashbackContainer>
                Earn
                <Styled.Cashback>
                  {dropZeroCents(
                    formatAsCurrencyWithCommasOrZero({
                      amount: commissionsCashBack(parseFloat(commissionsBalance.amount)),
                    }),
                  )}
                </Styled.Cashback>
                cash-back for Commissions spent online
              </Styled.CashbackContainer>
            )}
          </>
        )}
        <Styled.ButtonsContainer>
          <Styled.ShopButton to="/products">
            <Styled.BasketIcon />
            Shop Now
          </Styled.ShopButton>
          <Styled.DetailsAndPayoutButton to="/account/rewards/details-payouts">
            <Styled.ReceiptIcon />
            Details and Payouts
          </Styled.DetailsAndPayoutButton>
        </Styled.ButtonsContainer>
      </StyledCardInnerContainer>
    </Styled.Card>
  )
}
